// extracted by mini-css-extract-plugin
export var active = "_8r-a";
export var activeIndicator = "_8r-9";
export var disabled = "_8r-b";
export var fullWidth = "_8r-2";
export var lg = "_8r-7";
export var md = "_8r-6";
export var redoButtonTabGroup = "_8r-0";
export var sm = "_8r-5";
export var tabButton = "_8r-4";
export var tabButtonsContainer = "_8r-1";
export var themeDestructive = "_8r-d";
export var themeNormal = "_8r-c";
export var themeSuccess = "_8r-e";
export var xl = "_8r-8";
export var xs = "_8r-3";